const MEDIA_TYPE = {
  IMAGE: 'IMAGE',
  VIDEO: 'VIDEO',
  IMAGE360: 'IMAGE360'
}

export const getLabelText = (label) => {
  if (label === '2') return 'Bán'
  if (label === '1') return 'Thuê'
  if (label === '4') return 'Tìm mua'
  if (label === '3') return 'Tìm thuê'
  return ''
}

export const mapLabelToDemand = (label) => {
  const value = String(label)

  switch (value) {
    case '1':
      return 'rent'
    case '2':
      return 'sell'
    case '4':
      return 'buying'
    case '3':
      return 'renting'
    default:
      return null
  }
}
export const mapMediaFromApi = (postFiles = []) => ({
  images: postFiles
    .filter((f) => f.type === 'IMAGE')
    .map((f) => ({
      id: f.id,
      url: f.url || f.link,
      uploading: false
    })),

  videos: postFiles
    .filter((f) => f.type === 'VIDEO')
    .map((f) => ({
      id: f.id,
      url: f.url || f.link,
      uploading: false
    })),

  image_360: postFiles
    .filter((f) => f.type === 'IMAGE360')
    .map((f) => ({
      id: f.id,
      url: f.url || f.link,
      uploading: false
    }))
})
export const mapMediaForSubmit = (media) => {
  const result = []

  // IMAGE
  ;(media.images || []).forEach((item) => {
    if (!item.url || item.uploading) return
    result.push({
      link: item.url,
      type: MEDIA_TYPE.IMAGE,
      id: item.idBackend // nếu backend trả id rồi thì giữ
    })
  })

  // VIDEO
  ;(media.videos || []).forEach((item) => {
    if (!item.url || item.uploading) return
    result.push({
      link: item.url,
      type: MEDIA_TYPE.VIDEO,
      id: item.idBackend
    })
  })

  // IMAGE 360
  ;(media.image_360 || []).forEach((item) => {
    if (!item.url || item.uploading) return
    result.push({
      link: item.url,
      type: MEDIA_TYPE.IMAGE360,
      id: item.idBackend
    })
  })

  return result
}
export const validateImage360 = (file) =>
  new Promise((resolve, reject) => {
    const img = new Image()
    img.onload = () => {
      if (img.width < 300 || img.height < 300) {
        reject('Ảnh tối thiểu 300x300px')
      } else {
        resolve(true)
      }
    }
    img.onerror = () => reject('File không hợp lệ')
    img.src = URL.createObjectURL(file)
  })
